import { firestore } from '../utilities/firebase'
import errorTypes from '../enums/errorTypes'
import getCurrentUid from '../utilities/getCurrentUid'
import { errorOfType } from '../utilities/Errors'
import getUserProfile from './getUserProfile'

const addVerificationToUserByUserName = async (userName) => {
	const ownUserProfileId = getCurrentUid()
	try {
		const userProfilesCollection = firestore.collection('userProfiles')
		const ownUserProfileRef = userProfilesCollection.doc(ownUserProfileId)
		const ownUserProfileDoc = await ownUserProfileRef.get()
		const ownUserProfileData = ownUserProfileDoc.data()

		const { userProfile: otherUserProfilePublic } = await getUserProfile({ userName, fromPublic: true })
		const otherUserProfileId = otherUserProfilePublic.uid

		//	You cannot verify yourself, or user not found
		if (userName && ownUserProfileData && userName !== ownUserProfileData.userName && otherUserProfileId) {
			const ref = firestore.collection('userProfiles').doc(otherUserProfileId).collection('verifiers').doc(ownUserProfileId)
			await ref.set({ uid: ownUserProfileId })
			return { success: true, uid: otherUserProfileId, userName, realName: otherUserProfilePublic.realName }
		}
		return { success: false }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, userName, ownUserProfileId, exception)
	}
}

export default addVerificationToUserByUserName



// WEBPACK FOOTER //
// ./src/dataservices/addVerificationToUserByUserName.js